import { ChakraV3 } from '@piccolohealth/ui';
import React, { type ChangeEvent } from 'react';
import { useController } from 'react-hook-form';

interface Props extends ChakraV3.InputProps {
  name: string;
  noNulls?: boolean;
}

export const HookedInput = React.forwardRef<HTMLInputElement, Props>((props, forwardedRef) => {
  const { name, noNulls = false, ...rest } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  const mergedRef = ChakraV3.mergeRefs(ref, forwardedRef);

  const onChange = React.useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (noNulls) {
        inputProps.onChange(event.target.value);
      } else {
        event.target.value === ''
          ? inputProps.onChange(null)
          : inputProps.onChange(event.target.value);
      }
    },
    [inputProps.onChange, noNulls],
  );

  return (
    <ChakraV3.Input
      {...inputProps}
      onChange={onChange}
      value={inputProps.value}
      ref={mergedRef}
      size='sm'
      {...rest}
    />
  );
});
